import { getBanner, clickBanner, impressionBanner } from '@/apis/banner';
import { BANNER } from '../mutation-types';

export const state = {
  banner: [],
  bannerImpressionHistory: '',
  bannerClickHistory: '',
};

export const getters = {
  banner: state => state.banner
};
export const mutations = {
  [BANNER.GET_BANNER](state, data) {
    if (!data.error) {
      state.banner = data;
    }
  },
  [BANNER.BANNER_CLICK_HISTORY](state, data) {
    if (!data.error) {
      state.bannerClickHistory = data;
    }
  },
  [BANNER.BANNER_IMPRESSION_HISTORY](state, data) {
    state.bannerImpressionHistory = data;
  },
};

export const actions = {
  async getBanner({ commit }, params) {
    const res = await getBanner(params);
    commit(BANNER.GET_BANNER, res);

    return res;
  },

  async clickBanner({ commit }, payload) {
    const res = await clickBanner(payload);
    commit(BANNER.BANNER_CLICK_HISTORY, res);
  },

  async impressionBanner({ commit }, payload) {
    const res = await impressionBanner(payload);
    if (res) {
      return res;
    }
    commit(BANNER.BANNER_IMPRESSION_HISTORY, res);
    return false;
  },
};
